module.exports = __webpack_public_path__ + "img/expertise1.731c352f.png";